import $ from "jquery";
$(document).ready(function(){
    // Check if there is a component on the page first
    if (document.getElementsByClassName('c-breadcrumb').length) {
        $(".c-breadcrumb").scrollLeft($('.c-breadcrumb__list li:last-child').offset().left);
    }
});
